/**
 * @fileoverview Pure validation helpers for the NotificationForm page.
 * @module pages/notificationForm/notificationFormValidation
 */
import {
  NOTIFICATION_TYPE_EMAIL,
  NOTIFICATION_TYPE_APP,
  NOTIFICATION_TYPE_WHATSAPP,
} from "./notificationFormConstants.js";

const hasImageAttachment = (formData, imageFile) =>
  Boolean(formData.imagenUrl || imageFile);

const validateEmailNotification = (formData, imageFile) =>
  Boolean(
    formData.asunto &&
      formData.descripcion &&
      hasImageAttachment(formData, imageFile),
  );

const validateAppNotification = (formData) =>
  Boolean(formData.asunto && formData.descripcion);

const validateWhatsappNotification = (formData, imageFile) =>
  Boolean(formData.asunto && hasImageAttachment(formData, imageFile));

const TYPE_VALIDATORS = {
  [NOTIFICATION_TYPE_EMAIL]: validateEmailNotification,
  [NOTIFICATION_TYPE_APP]: validateAppNotification,
  [NOTIFICATION_TYPE_WHATSAPP]: validateWhatsappNotification,
};

/** Returns whether the form has enough data to create a notification. */
export const canCreateNotification = (formData, imageFile) => {
  const { tipo } = formData;
  if (tipo === null) {
    return false;
  }

  const hasAudienceSelection =
    formData.audienciaParaSocios || formData.audienciaParaNoSocios;
  if (!hasAudienceSelection) {
    return false;
  }

  const validator = TYPE_VALIDATORS[tipo.value];
  return validator ? validator(formData, imageFile) : false;
};
